import { EmailAssistantModal } from '@frontend/email-assistant-modal';
import { useTranslation } from '@frontend/i18n';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { useModalControl } from '@frontend/design-system';
import { useContentComposer } from '../../content-composer/content-composer-provider';
import { ToolboxButton } from '../../content-composer/toolbox-atoms/toolbox-button';
import { ToolboxDivider } from '../../content-composer/toolbox-atoms/toolbox-divider';
import { emailAssistantGradientStyling } from '../../styles';
import { TextSection } from '../text-section/text-section';

export const EmailAssistant = () => {
  const { t } = useTranslation('content-composer');
  const { insertSection, promptProps } = useContentComposer();
  const { modalProps, triggerProps } = useModalControl();

  return (
    <>
      <ToolboxButton
        icon='aiassistant'
        title={t('Weave AI')}
        subtitle={t('Automatically generate content for your email campaign.')}
        onClick={triggerProps.onClick}
        css={emailAssistantGradientStyling}
        trackingId={`${BulkEmailPrefixes.Composer}-assisant-tool-btn`}
      />
      <ToolboxDivider />
      <EmailAssistantModal
        modalProps={modalProps}
        onComplete={(value: string) => insertSection(<TextSection text={value} />)}
        promptProps={promptProps}
        type='text'
      />
    </>
  );
};
